import image1 from '../../../assets/image1.png';
import image2 from '../../../assets/image2.png';
import image3 from '../../../assets/image3.png';
import image4 from '../../../assets/image4.png';
import image5 from '../../../assets/image5.png';
import image6 from '../../../assets/image6.png';
import image7 from '../../../assets/image7.png';
import image8 from '../../../assets/image8.png';
import image9 from '../../../assets/image9.png';

export default [
    {
        title: 'limited edition Catalog',
        imgSrc: image1
    }, 
    {
        title: 'Gift packaging',
        imgSrc: image2
    }, 
    {
        title: 'Sales leaflet',
        imgSrc: image3
    }, 
    {
        title: 'Branding for WPH',
        imgSrc: image4
    }, 
    {
        title: 'Military store website',
        imgSrc: image5
    }, 
    {
        title: 'Graphics for children',
        imgSrc: image6
    }, 
    {
        title: 'design of the application',
        imgSrc: image7
    }, 
    {
        title: 'Website design',
        imgSrc: image8
    },
    {
        title: 'Advertising campaign',
        imgSrc: image9
    },
];